import DataDictionary from "./DataDictionary";
export default DataDictionary;
